import PrestigeLevelsMainPage from './main';
import PrestigeLevelsEdit from './edit';
import SinglePrestigeLevels from './singlePrestige';

const routes = [
  {
    path: '/*',
    Component: PrestigeLevelsMainPage,
    props: {},
  },
  {
    path: '/:id/edit',
    Component: PrestigeLevelsEdit,
    props: {},
  },
  {
    path: '/:id',
    Component: SinglePrestigeLevels,
    props: {},
  },
  {
    path: '/new',
    Component: PrestigeLevelsEdit,
    props: {
      isNew: true,
    },
  },
];

export default routes;
